module.exports = __webpack_public_path__ + "img/item4.20b4dbcf.png";